import React from 'react';
import ApproveFunctional from './component/approve-functional';
import './approve.scss';

const ApprovePage = () => {
	return <ApproveFunctional />;
};
export default ApprovePage;
